import React from "react";
import * as Icons from "lucide-react";

export default function ServiceIcon({ name, className = "w-6 h-6" }) {
  const Icon = Icons[name] || Icons.Wrench;
  return <Icon className={className} strokeWidth={1.6} />;
}
